/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface SendAmWelcomeEmail$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendAmWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendAmWelcomeEmailRequest = createAction<PayloadData<void, SendAmWelcomeEmail$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL__REQUEST');
export const sendAmWelcomeEmailSuccess = createAction<PayloadData<void, SendAmWelcomeEmail$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL__SUCCESS');
export const sendAmWelcomeEmailFailure = createAction<PayloadData<Error, SendAmWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL__FAILURE');

export const sendAmWelcomeEmailActions = [
    sendAmWelcomeEmailRequest,
    sendAmWelcomeEmailSuccess,
    sendAmWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendAmWelcomeEmail = (meta: SendAmWelcomeEmail$Request, config?: SendAmWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendAmWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/account-team-welcome-email`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendAmWelcomeEmailNoGift$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendAmWelcomeEmailNoGift$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendAmWelcomeEmailNoGiftRequest = createAction<PayloadData<void, SendAmWelcomeEmailNoGift$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT__REQUEST');
export const sendAmWelcomeEmailNoGiftSuccess = createAction<PayloadData<void, SendAmWelcomeEmailNoGift$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT__SUCCESS');
export const sendAmWelcomeEmailNoGiftFailure = createAction<PayloadData<Error, SendAmWelcomeEmailNoGift$Request, true>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT__FAILURE');

export const sendAmWelcomeEmailNoGiftActions = [
    sendAmWelcomeEmailNoGiftRequest,
    sendAmWelcomeEmailNoGiftSuccess,
    sendAmWelcomeEmailNoGiftFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendAmWelcomeEmailNoGift = (meta: SendAmWelcomeEmailNoGift$Request, config?: SendAmWelcomeEmailNoGift$Config) => {
    return {
        CALL_API: {
            types: sendAmWelcomeEmailNoGiftActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/account-team-welcome-email-no-gift`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendAmWelcomeEmailNoGiftSso$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendAmWelcomeEmailNoGiftSso$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendAmWelcomeEmailNoGiftSsoRequest = createAction<PayloadData<void, SendAmWelcomeEmailNoGiftSso$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT_SSO__REQUEST');
export const sendAmWelcomeEmailNoGiftSsoSuccess = createAction<PayloadData<void, SendAmWelcomeEmailNoGiftSso$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT_SSO__SUCCESS');
export const sendAmWelcomeEmailNoGiftSsoFailure = createAction<PayloadData<Error, SendAmWelcomeEmailNoGiftSso$Request, true>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_NO_GIFT_SSO__FAILURE');

export const sendAmWelcomeEmailNoGiftSsoActions = [
    sendAmWelcomeEmailNoGiftSsoRequest,
    sendAmWelcomeEmailNoGiftSsoSuccess,
    sendAmWelcomeEmailNoGiftSsoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendAmWelcomeEmailNoGiftSso = (meta: SendAmWelcomeEmailNoGiftSso$Request, config?: SendAmWelcomeEmailNoGiftSso$Config) => {
    return {
        CALL_API: {
            types: sendAmWelcomeEmailNoGiftSsoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/account-team-welcome-email-no-gift-sso`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendAmWelcomeEmailSso$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendAmWelcomeEmailSso$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendAmWelcomeEmailSsoRequest = createAction<PayloadData<void, SendAmWelcomeEmailSso$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_SSO__REQUEST');
export const sendAmWelcomeEmailSsoSuccess = createAction<PayloadData<void, SendAmWelcomeEmailSso$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_SSO__SUCCESS');
export const sendAmWelcomeEmailSsoFailure = createAction<PayloadData<Error, SendAmWelcomeEmailSso$Request, true>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_SSO__FAILURE');

export const sendAmWelcomeEmailSsoActions = [
    sendAmWelcomeEmailSsoRequest,
    sendAmWelcomeEmailSsoSuccess,
    sendAmWelcomeEmailSsoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendAmWelcomeEmailSso = (meta: SendAmWelcomeEmailSso$Request, config?: SendAmWelcomeEmailSso$Config) => {
    return {
        CALL_API: {
            types: sendAmWelcomeEmailSsoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/account-team-welcome-email-sso`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendAmWelcomeEmailTrial$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendAmWelcomeEmailTrial$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendAmWelcomeEmailTrialRequest = createAction<PayloadData<void, SendAmWelcomeEmailTrial$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_TRIAL__REQUEST');
export const sendAmWelcomeEmailTrialSuccess = createAction<PayloadData<void, SendAmWelcomeEmailTrial$Request>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_TRIAL__SUCCESS');
export const sendAmWelcomeEmailTrialFailure = createAction<PayloadData<Error, SendAmWelcomeEmailTrial$Request, true>>('USERS_EMAILS__SEND_AM_WELCOME_EMAIL_TRIAL__FAILURE');

export const sendAmWelcomeEmailTrialActions = [
    sendAmWelcomeEmailTrialRequest,
    sendAmWelcomeEmailTrialSuccess,
    sendAmWelcomeEmailTrialFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendAmWelcomeEmailTrial = (meta: SendAmWelcomeEmailTrial$Request, config?: SendAmWelcomeEmailTrial$Config) => {
    return {
        CALL_API: {
            types: sendAmWelcomeEmailTrialActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/account-team-welcome-email-trial`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendLlmOnlyWelcomeEmail$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface SendLlmOnlyWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendLlmOnlyWelcomeEmailRequest = createAction<PayloadData<void, SendLlmOnlyWelcomeEmail$Request>>('USERS_EMAILS__SEND_LLM_ONLY_WELCOME_EMAIL__REQUEST');
export const sendLlmOnlyWelcomeEmailSuccess = createAction<PayloadData<void, SendLlmOnlyWelcomeEmail$Request>>('USERS_EMAILS__SEND_LLM_ONLY_WELCOME_EMAIL__SUCCESS');
export const sendLlmOnlyWelcomeEmailFailure = createAction<PayloadData<Error, SendLlmOnlyWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_LLM_ONLY_WELCOME_EMAIL__FAILURE');

export const sendLlmOnlyWelcomeEmailActions = [
    sendLlmOnlyWelcomeEmailRequest,
    sendLlmOnlyWelcomeEmailSuccess,
    sendLlmOnlyWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendLlmOnlyWelcomeEmail = (meta: SendLlmOnlyWelcomeEmail$Request, config?: SendLlmOnlyWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendLlmOnlyWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/llm-only-welcome-email`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendLoginLinkEmail$Request {
    userId: number;
}

export interface SendLoginLinkEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendLoginLinkEmailRequest = createAction<PayloadData<void, SendLoginLinkEmail$Request>>('USERS_EMAILS__SEND_LOGIN_LINK_EMAIL__REQUEST');
export const sendLoginLinkEmailSuccess = createAction<PayloadData<void, SendLoginLinkEmail$Request>>('USERS_EMAILS__SEND_LOGIN_LINK_EMAIL__SUCCESS');
export const sendLoginLinkEmailFailure = createAction<PayloadData<Error, SendLoginLinkEmail$Request, true>>('USERS_EMAILS__SEND_LOGIN_LINK_EMAIL__FAILURE');

export const sendLoginLinkEmailActions = [
    sendLoginLinkEmailRequest,
    sendLoginLinkEmailSuccess,
    sendLoginLinkEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendLoginLinkEmail = (meta: SendLoginLinkEmail$Request, config?: SendLoginLinkEmail$Config) => {
    return {
        CALL_API: {
            types: sendLoginLinkEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/login-link`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendNewClientWelcomeEmail$Request {
    userId: number;
}

export interface SendNewClientWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendNewClientWelcomeEmailRequest = createAction<PayloadData<void, SendNewClientWelcomeEmail$Request>>('USERS_EMAILS__SEND_NEW_CLIENT_WELCOME_EMAIL__REQUEST');
export const sendNewClientWelcomeEmailSuccess = createAction<PayloadData<void, SendNewClientWelcomeEmail$Request>>('USERS_EMAILS__SEND_NEW_CLIENT_WELCOME_EMAIL__SUCCESS');
export const sendNewClientWelcomeEmailFailure = createAction<PayloadData<Error, SendNewClientWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_NEW_CLIENT_WELCOME_EMAIL__FAILURE');

export const sendNewClientWelcomeEmailActions = [
    sendNewClientWelcomeEmailRequest,
    sendNewClientWelcomeEmailSuccess,
    sendNewClientWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendNewClientWelcomeEmail = (meta: SendNewClientWelcomeEmail$Request, config?: SendNewClientWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendNewClientWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/new-client-welcome-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendOriginWelcomeEmail$Request {
    userId: number;
}

export interface SendOriginWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendOriginWelcomeEmailRequest = createAction<PayloadData<void, SendOriginWelcomeEmail$Request>>('USERS_EMAILS__SEND_ORIGIN_WELCOME_EMAIL__REQUEST');
export const sendOriginWelcomeEmailSuccess = createAction<PayloadData<void, SendOriginWelcomeEmail$Request>>('USERS_EMAILS__SEND_ORIGIN_WELCOME_EMAIL__SUCCESS');
export const sendOriginWelcomeEmailFailure = createAction<PayloadData<Error, SendOriginWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_ORIGIN_WELCOME_EMAIL__FAILURE');

export const sendOriginWelcomeEmailActions = [
    sendOriginWelcomeEmailRequest,
    sendOriginWelcomeEmailSuccess,
    sendOriginWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendOriginWelcomeEmail = (meta: SendOriginWelcomeEmail$Request, config?: SendOriginWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendOriginWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/origin-welcome-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendPasswordSharingWarningEmail$Request {
    userId: number;
}

export interface SendPasswordSharingWarningEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendPasswordSharingWarningEmailRequest = createAction<PayloadData<void, SendPasswordSharingWarningEmail$Request>>('USERS_EMAILS__SEND_PASSWORD_SHARING_WARNING_EMAIL__REQUEST');
export const sendPasswordSharingWarningEmailSuccess = createAction<PayloadData<void, SendPasswordSharingWarningEmail$Request>>('USERS_EMAILS__SEND_PASSWORD_SHARING_WARNING_EMAIL__SUCCESS');
export const sendPasswordSharingWarningEmailFailure = createAction<PayloadData<Error, SendPasswordSharingWarningEmail$Request, true>>('USERS_EMAILS__SEND_PASSWORD_SHARING_WARNING_EMAIL__FAILURE');

export const sendPasswordSharingWarningEmailActions = [
    sendPasswordSharingWarningEmailRequest,
    sendPasswordSharingWarningEmailSuccess,
    sendPasswordSharingWarningEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendPasswordSharingWarningEmail = (meta: SendPasswordSharingWarningEmail$Request, config?: SendPasswordSharingWarningEmail$Config) => {
    return {
        CALL_API: {
            types: sendPasswordSharingWarningEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/password-sharing-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendResetPasswordEmail$Request {
    userId: number;
}

export interface SendResetPasswordEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendResetPasswordEmailRequest = createAction<PayloadData<void, SendResetPasswordEmail$Request>>('USERS_EMAILS__SEND_RESET_PASSWORD_EMAIL__REQUEST');
export const sendResetPasswordEmailSuccess = createAction<PayloadData<void, SendResetPasswordEmail$Request>>('USERS_EMAILS__SEND_RESET_PASSWORD_EMAIL__SUCCESS');
export const sendResetPasswordEmailFailure = createAction<PayloadData<Error, SendResetPasswordEmail$Request, true>>('USERS_EMAILS__SEND_RESET_PASSWORD_EMAIL__FAILURE');

export const sendResetPasswordEmailActions = [
    sendResetPasswordEmailRequest,
    sendResetPasswordEmailSuccess,
    sendResetPasswordEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendResetPasswordEmail = (meta: SendResetPasswordEmail$Request, config?: SendResetPasswordEmail$Config) => {
    return {
        CALL_API: {
            types: sendResetPasswordEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/reset-password`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendSmbWelcomeEmail$Request {
    userId: number;
}

export interface SendSmbWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendSmbWelcomeEmailRequest = createAction<PayloadData<void, SendSmbWelcomeEmail$Request>>('USERS_EMAILS__SEND_SMB_WELCOME_EMAIL__REQUEST');
export const sendSmbWelcomeEmailSuccess = createAction<PayloadData<void, SendSmbWelcomeEmail$Request>>('USERS_EMAILS__SEND_SMB_WELCOME_EMAIL__SUCCESS');
export const sendSmbWelcomeEmailFailure = createAction<PayloadData<Error, SendSmbWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_SMB_WELCOME_EMAIL__FAILURE');

export const sendSmbWelcomeEmailActions = [
    sendSmbWelcomeEmailRequest,
    sendSmbWelcomeEmailSuccess,
    sendSmbWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendSmbWelcomeEmail = (meta: SendSmbWelcomeEmail$Request, config?: SendSmbWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendSmbWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/smb-welcome-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendStartupWelcomeEmail$Request {
    userId: number;
}

export interface SendStartupWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendStartupWelcomeEmailRequest = createAction<PayloadData<void, SendStartupWelcomeEmail$Request>>('USERS_EMAILS__SEND_STARTUP_WELCOME_EMAIL__REQUEST');
export const sendStartupWelcomeEmailSuccess = createAction<PayloadData<void, SendStartupWelcomeEmail$Request>>('USERS_EMAILS__SEND_STARTUP_WELCOME_EMAIL__SUCCESS');
export const sendStartupWelcomeEmailFailure = createAction<PayloadData<Error, SendStartupWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_STARTUP_WELCOME_EMAIL__FAILURE');

export const sendStartupWelcomeEmailActions = [
    sendStartupWelcomeEmailRequest,
    sendStartupWelcomeEmailSuccess,
    sendStartupWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendStartupWelcomeEmail = (meta: SendStartupWelcomeEmail$Request, config?: SendStartupWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendStartupWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/startup-welcome-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendWelcomeEmail$Request {
    userId: number;
}

export interface SendWelcomeEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendWelcomeEmailRequest = createAction<PayloadData<void, SendWelcomeEmail$Request>>('USERS_EMAILS__SEND_WELCOME_EMAIL__REQUEST');
export const sendWelcomeEmailSuccess = createAction<PayloadData<void, SendWelcomeEmail$Request>>('USERS_EMAILS__SEND_WELCOME_EMAIL__SUCCESS');
export const sendWelcomeEmailFailure = createAction<PayloadData<Error, SendWelcomeEmail$Request, true>>('USERS_EMAILS__SEND_WELCOME_EMAIL__FAILURE');

export const sendWelcomeEmailActions = [
    sendWelcomeEmailRequest,
    sendWelcomeEmailSuccess,
    sendWelcomeEmailFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendWelcomeEmail = (meta: SendWelcomeEmail$Request, config?: SendWelcomeEmail$Config) => {
    return {
        CALL_API: {
            types: sendWelcomeEmailActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/emails/welcome-email`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

